import api from "./api";

const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
export const MAPS_ENABLED = !!MAPS_KEY;
let _mapsPromise = null;

// Load the Google Maps JS API once (shared across the app). Resolves with google.maps.
export function loadGoogleMaps() {
  if (!MAPS_KEY) return Promise.reject(new Error("Google Maps key not configured"));
  if (window.google && window.google.maps) return Promise.resolve(window.google.maps);
  if (_mapsPromise) return _mapsPromise;
  _mapsPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_KEY}`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(window.google.maps);
    s.onerror = () => { _mapsPromise = null; reject(new Error("Google Maps failed to load")); };
    document.head.appendChild(s);
  });
  return _mapsPromise;
}


// Free Google Maps "search" link built from address text (no API cost).
export function mapsSearchUrl(query) {
  if (!query || !query.trim()) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query.trim())}`;
}

// Directions link from an origin address to a destination address.
export function mapsDirUrl(origin, destination) {
  return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent((origin || "").trim())}&destination=${encodeURIComponent((destination || "").trim())}`;
}

// Best-effort "City, State" from a raw address string when geocoding is unavailable.
export function cityStateFallback(addr) {
  const parts = (addr || "").split(",").map((s) => s.trim())
    .filter(Boolean)
    .filter((p) => !/^\d{5,6}$/.test(p) && p.toLowerCase() !== "india");
  if (parts.length >= 2) return parts.slice(-2).join(", ");
  return parts[parts.length - 1] || (addr || "").trim();
}

// Resolve a "City, ST" label for an address via the backend geocoder.
export async function resolveCityState(address) {
  if (!address || !address.trim()) return "";
  try {
    const { data } = await api.get("/places/resolve", { params: { address } });
    return data.city_state || cityStateFallback(address);
  } catch {
    return cityStateFallback(address);
  }
}
